
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import InboxIcon from "@material-ui/icons/Inbox";


import Dropable from "../Dropable";
import Typography from '@material-ui/core/Typography';
import { Link } from "react-router-dom";
import { connect } from "react-redux";

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%",
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper
    },
    nested: {
        paddingLeft: theme.spacing(4)
    },
    listItemText: {
        textDecoration: 'none',
        color: theme.palette.text.primary
    }
}));

const CaptureItems = props => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);

    const handleClick = () => {
        setOpen(!open);
    };

    const myTextStyle = {
        backgroundColor: 'pink',
        textDecoration: 'none',
        '&:hover': {
            color: 'red'
        }
    };

    return (
        <div>
            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                className={classes.root}
            >
                <Dropable name="">

                    <Link to="/inbox">
                        <Typography color="inherit">
                            <ListItem button onClick={handleClick}>
                                <ListItemIcon classes={{ root: 'new-MuiListItemIcon-root' }}>
                                    <InboxIcon />
                                    {!props.isOpenDrawer && <div>Inbox</div>}
                                </ListItemIcon>
                                <ListItemText primary={
                                    props.tasksInboxCounter ? `Inbox (${props.tasksInboxCounter})` : `Inbox`
                                } disableTypography={true} className={classes.listItemText} />
                            </ListItem>
                        </Typography>
                    </Link>

                </Dropable>
            </List>
        </div>
    );
}

const mapStateToProps = state => {
    function isInbox(idTask) {
        const task = state.tasks[idTask];
        return (!task.done && !task.focus && !task.project && !task.parent && task.action === "");
    }

    const tasksInbox = state.tasks && Object.keys(state.tasks).filter(isInbox);

    return {
        tasksInboxCounter: tasksInbox ? tasksInbox.length : null,
    };
};

export default connect(mapStateToProps, null)(CaptureItems);